import { Component, OnInit, Input } from '@angular/core';
import { DipStateService } from '../services/dip-state-service.service';

@Component({
    selector: 'page-header',
    templateUrl: './page-header.component.html',
    styleUrls: ['./page-header.component.scss'],
    standalone: false
})
export class PageHeaderComponent implements OnInit {
    /**
     * Current active step
     * @type number
     * @memberof PageHeaderComponent
     */
    @Input() currentStep: number;
    /**
     * Total number of stemp
     * @type number
     * @memberof PageHeaderComponent
     */
    @Input() totalSteps: number;
    /**
     * The title
     */
    title: string;
    /**
     * The sub title
     */
    subTitle: string;

     /**
     * The sub title
     */
    summary: string;

    /**
     * The header image
     */
    @Input() headerImage: string;
    /**
     * Constructor
     * @memberof PageHeaderComponent
     */
    constructor(private state: DipStateService) {
        this.title = this.state.pageTitle.getValue();
        this.subTitle = this.state.pageSubTitle.getValue();
        this.summary = this.state.pageSummary.getValue();
        this.state.pageTitle.subscribe((next) => {
            this.title = next;
        });
        this.state.pageSubTitle.subscribe((next) => {
            this.subTitle = next;
        });

        this.state.pageSummary.subscribe((next) => {
            this.summary = next;
        });
    }

    /**
     * Initisalise component
     * @memberof PageHeaderComponent
     */
    ngOnInit() {
    }

}
